import { Box, MenuItem, TextField } from "@mui/material";
import type { ReactNode } from "react";
import type { Currency } from "../lib/types";

/** Label with a leading icon, shared by record-style forms. */
export function recordFieldLabel(label: string, icon: ReactNode) {
  return (
    <span className="record-field-label">
      {icon}
      <span>{label}</span>
    </span>
  );
}

export function MoneyInputGroup({
  label,
  name,
  amount,
  currency,
  currencies,
  disabled,
  amountDisabled,
  error,
  helperText,
  currencyLocked = false,
  labelIcon,
  onAmountChange,
  onCurrencyChange,
}: {
  label: string;
  name: string;
  amount: string;
  currency: string;
  currencies: Currency[];
  disabled?: boolean;
  amountDisabled?: boolean;
  error?: boolean;
  helperText?: string;
  currencyLocked?: boolean;
  labelIcon?: ReactNode;
  onAmountChange?: (value: string) => void;
  onCurrencyChange?: (value: string) => void;
}) {
  return (
    <Box className="money-input-group">
      <TextField
        required
        error={error}
        helperText={helperText}
        label={labelIcon ? recordFieldLabel(label, labelIcon) : label}
        name={name}
        inputMode="decimal"
        placeholder="29.99"
        value={amount}
        disabled={disabled || amountDisabled}
        onChange={(event) => onAmountChange?.(event.target.value)}
        slotProps={{
          inputLabel: { shrink: true },
        }}
      />
      <TextField
        select
        className="money-input-currency"
        name={currencyLocked ? undefined : "currency"}
        value={currency}
        disabled={disabled || currencyLocked}
        aria-label={`${label} currency`}
        onChange={(event) => onCurrencyChange?.(String(event.target.value))}
      >
        {currencies.map((option) => (
          <MenuItem key={option.code} value={option.code}>
            {option.symbol} {option.code}
          </MenuItem>
        ))}
      </TextField>
      {currencyLocked ? <input type="hidden" name="account_currency" value={currency} /> : null}
    </Box>
  );
}
